/* Researched Elements product page enhancements (product owner, 10/08/26).
   1. Turns the product description into tabs (Overview, How to use, Ingredients, Cautions & allergens) with
      keyboard support and deep links (#how-to-use), and the age dosing lines into a table.
   2. Tidies legacy description HTML for display only (no copy is rewritten): rainbow inline colors, all-caps
      link labels, bold label lines, "**" note markers, duplicate FDA statements.
   3. Shows ingredient amounts as a clean 2-column facts list, and an "at a glance" row of facts parsed from the label text.
   4. Sticky add to cart on phones: short product name and form chips that drive the real form picker.
   5. Small polish: "$97.00" shows as "$97" on this page, first gallery thumbnails load right away.
   Leaves the description untouched if it finds no headings. */
(function () {
  'use strict';
  function txt(n) { return (n && n.textContent || '').replace(/\s+/g, ' ').trim(); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function slug(s) { return s.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  /* ---------- 1. Tabs ---------- */
  function isHead(n) {
    if (n.nodeType !== 1) return false;
    if (/^H[234]$/.test(n.tagName) && !n.classList.contains('re-tabs__sub')) return true;
    if (n.tagName === 'P') {
      var t = txt(n);
      if (t.length >= 40) return false;
      var kids = [].filter.call(n.children, function (c) { return c.tagName !== 'BR'; });
      var strongOnly = kids.length === 1 && /^(STRONG|B|U)$/.test(kids[0].tagName) && txt(kids[0]) === t;
      return (/:$/.test(t) || strongOnly) && /^(how to (take|use)|directions|recommended use|suggested use|dosing( regimen)?|ingredients|supplement facts|caution|cautions|warnings?|what.?s inside( every (scoop|serving|capsule))?|instructions for use.*|claims of use):?$/i.test(t);
    }
    return false;
  }
  function findDesc() {
    var tagged = document.querySelector('[data-re-desc]');
    if (tagged) return tagged;
    var scope = document.querySelector('.product-information') || document;
    var heads = [].slice.call(scope.querySelectorAll('h2,h3,h4,p')).filter(function (h) {
      return !h.closest('.re-tabs,.re-pdp-head,.re-assure,.re-pairs,.re-more,.accordion,details') &&
        /^(how to (use|take)|ingredients|directions|supplement facts|recommended use|dosing|caution)/i.test(txt(h));
    });
    return heads.length ? heads[0].parentElement : null;
  }
  var AGE = /^(infants?|toddlers?|children|kids|adults?|ages?)\b[^:]{0,40}:\s*(.+)$/i;
  function dosingTable(nodes) {
    var form = 'Dose', forms = [], rows = {}, order = [], used = [];
    nodes.forEach(function (n) {
      if (n.nodeType !== 1) return;
      var lines = /^(UL|OL)$/.test(n.tagName)
        ? [].map.call(n.querySelectorAll('li'), txt).filter(Boolean)
        : n.innerHTML.split(/<br\s*\/?>/i).map(function (s) { var d = document.createElement('div'); d.innerHTML = s; return txt(d); }).filter(Boolean);
      var hit = false;
      lines.forEach(function (l) {
        var m = l.match(AGE);
        if (m && /\d/.test(l.slice(l.indexOf(':') + 1))) {
          hit = true;
          var age = l.split(':')[0].trim(), dose = l.slice(l.indexOf(':') + 1).trim();
          if (!rows[age]) { rows[age] = {}; order.push(age); }
          var f = form;
          if (f === 'Dose') { if (/scoop/i.test(dose)) f = 'Powder'; else if (/capsule/i.test(dose)) f = 'Capsules'; else if (/pump|dime/i.test(dose)) f = 'Lotion'; }
          rows[age][f] = dose;
          if (forms.indexOf(f) < 0) forms.push(f);
        }
      });
      var t = txt(n);
      if (!hit) { var fm = t.match(/^(powders?|capsules?|lotion|liquid)\b/i); if (fm) { var w = fm[1].toLowerCase(); form = /^powder/.test(w) ? 'Powder' : /^capsule/.test(w) ? 'Capsules' : w.charAt(0).toUpperCase() + w.slice(1); } }
      if (hit) used.push(n);
    });
    if (order.length < 2) return null;
    var tbl = el('table', 're-dose');
    var h = '<caption class="re-dose__cap">Daily dose by age</caption><thead><tr><th scope="col">Age</th>' + forms.map(function (f) { return '<th scope="col">' + f + '</th>'; }).join('') + '</tr></thead><tbody>';
    order.forEach(function (a) { h += '<tr><th scope="row">' + a + '</th>' + forms.map(function (f) { return '<td>' + (rows[a][f] || '') + '</td>'; }).join('') + '</tr>'; });
    tbl.innerHTML = h + '</tbody>';
    var wrap = el('div', 're-dose__wrap'); wrap.appendChild(tbl);
    return { table: wrap, used: used };
  }

  /* ---------- 2. Legacy HTML tidy (display only) ---------- */
  var BRANDS = /\b(spectrum max|mega motility|gut guardian|histamine halt|serene calm|candida hunter|mucosa master|prebiotic repair|colostrum fusion|bifidofusion|bifidoboss|thioguard|glutathione genesis|ammonia away|oxalate relief|mito mind|microbiome diversity|researched elements)\b/gi;
  var KEEP_UPPER = /^(GI|DAO|USA|FDA|NAC|MSM|PEA|CFUS?|GMO|MCT|PDF|ASD|IBS|PHGG|GOS|SIBO|DNA|RNA|ATP|NSF|EPA|DHA|II|III|IV|V1|V2|AZ1|AZ2|KLL|MB12|B12|B6|B1|B2|D3|K2|K1|COQ10|STS|GSSG|GSH|ID)$/;
  function sentenceCase(s) {
    var first = true;
    return s.replace(/[A-Za-z0-9+]+|[.!?]/g, function (w) {
      if (/^[.!?]$/.test(w)) { first = true; return w; }
      var out;
      if (KEEP_UPPER.test(w.toUpperCase()) || /\d/.test(w)) out = w;
      else out = w.toLowerCase();
      if (first && out) { out = out.charAt(0).toUpperCase() + out.slice(1); first = false; }
      return out;
    }).replace(BRANDS, function (b) { return b.replace(/(^|\s|\+|&\s)([a-z])/g, function (m, a, c) { return a + c.toUpperCase(); }); });
  }
  function isShouting(t) {
    var letters = t.replace(/[^A-Za-z]/g, '');
    return letters.length >= 8 && letters === letters.toUpperCase() && t.split(/\s+/).length >= 2;
  }
  function tidy(panel, isIngredients) {
    // Inline colors, fonts and sizes from the old store editor.
    [].forEach.call(panel.querySelectorAll('[style]'), function (n) {
      n.style.removeProperty('color'); n.style.removeProperty('background-color'); n.style.removeProperty('font-family');
      n.style.removeProperty('font-size'); n.style.removeProperty('text-transform'); n.style.removeProperty('line-height');
      if (!n.getAttribute('style') || !n.getAttribute('style').trim()) n.removeAttribute('style');
    });
    [].forEach.call(panel.querySelectorAll('font'), function (n) { n.removeAttribute('color'); n.removeAttribute('face'); n.removeAttribute('size'); });
    // Leading and trailing line breaks left by the old editor open big gaps above and below blocks.
    [].forEach.call(panel.querySelectorAll('p, li'), function (p) {
      ['firstChild', 'lastChild'].forEach(function (end) {
        var c = p[end];
        while (c && ((c.nodeType === 3 && !c.nodeValue.replace(/\u00a0/g, ' ').trim()) || (c.nodeType === 1 && c.tagName === 'BR'))) { var x = c; c = end === 'firstChild' ? c.nextSibling : c.previousSibling; p.removeChild(x); }
      });
    });
    // All-caps link labels and short all-caps lines read as shouting; show them in sentence case.
    [].forEach.call(panel.querySelectorAll('a, p, li, strong, span'), function (n) {
      if (n.children.length && n.tagName !== 'A') return;
      var t = txt(n);
      if (isIngredients || t.length > 160 || !isShouting(t)) return;
      if (n.tagName === 'A' || n.children.length === 0) { n.textContent = sentenceCase(t); n.classList.add('re-was-caps'); }
    });
    [].forEach.call(panel.querySelectorAll('a[href]'), function (a) {
      if (/^https?:/i.test(a.getAttribute('href')) && a.host !== location.host) {
        a.classList.add('re-ext');
        if (a.target === '_blank') {
          var rel = (a.getAttribute('rel') || '').split(/\s+/);
          if (rel.indexOf('noopener') < 0) rel.push('noopener');
          a.setAttribute('rel', rel.join(' ').trim());
          if (!a.querySelector('.visually-hidden')) a.appendChild(el('span', 'visually-hidden', ' (opens in a new tab)'));
        }
      }
    });
    // Paragraph-level roles.
    [].forEach.call(panel.querySelectorAll(':scope > p'), function (p) {
      var t = txt(p);
      if (!t) { if (!p.querySelector('img,iframe,video')) p.classList.add('re-empty'); return; }
      var strongOnly = p.children.length === 1 && /^(STRONG|B)$/.test(p.children[0].tagName) && txt(p.children[0]) === t;
      if (strongOnly && t.length <= 70 && !/[.!]$/.test(t)) { p.classList.add('re-tabs__label'); return; }
      if (strongOnly && t.length > 70) { p.classList.add('re-tabs__note'); return; }
      if (/^\*{1,2}\s*(note|we cannot|please note)/i.test(t)) {
        p.classList.add('re-tabs__fine');
        // Drop a leading "**" note marker (it points to nothing); a single "*" stays because it ties to the FDA statement.
        var walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null, false), tn;
        while ((tn = walker.nextNode())) { if (/\S/.test(tn.nodeValue)) { tn.nodeValue = tn.nodeValue.replace(/^\s*\*\*\s*/, ''); break; } }
      }
    });
    // Lists of bold links (resource links) become a tidy link list.
    [].forEach.call(panel.querySelectorAll(':scope > ul'), function (ul) {
      var lis = ul.querySelectorAll(':scope > li');
      if (lis.length && [].every.call(lis, function (li) { return txt(li).length < 80 && (li.querySelector('a') || li.querySelector('strong')); }) &&
          [].some.call(lis, function (li) { return li.querySelector('a[href]'); })) ul.classList.add('re-tabs__links');
    });
  }

  /* ---------- 3. Ingredient amounts and glance facts ---------- */
  function factsList(ul) {
    var lis = [].slice.call(ul.querySelectorAll(':scope > li'));
    if (lis.length < 3) return null;
    var parsed = lis.map(function (li) {
      var t = txt(li).replace(/^[•·]\s*/, '');
      var i = t.search(/\s\d[\d,.]*\s*(?:mg|mcg|µg|g|iu|ml|billion cfus?|cfus?)\b/i);
      if (i < 1 || i > t.length - 2) return null;
      var name = t.slice(0, i).replace(/\s*:\s*$/, '').trim(), amt = t.slice(i).trim();
      return name ? { name: name, amt: amt } : null;
    });
    var ok = parsed.filter(Boolean).length;
    if (ok < Math.ceil(lis.length * 0.6)) return null;
    var dl = el('dl', 're-facts');
    parsed.forEach(function (p, k) {
      var row = el('div', 're-facts__row');
      if (p) { row.appendChild(el('dt', null)).textContent = p.name; row.appendChild(el('dd', null)).textContent = p.amt; }
      else { row.classList.add('re-facts__row--full'); row.appendChild(el('dt', null)).textContent = txt(lis[k]); row.appendChild(el('dd', null, '')); }
      dl.appendChild(row);
    });
    return dl;
  }
  function servings(text) {
    var nums = [], about = false, re = /servings?\s+per\s+container:?\s*(about\s*)?(\d{1,4})|(about\s*)?(\d{1,4})\s+servings\s+per\s+container/gi, m;
    while ((m = re.exec(text))) { var n = m[2] || m[4]; if (m[1] || m[3]) about = true; nums.push(n); }
    if (!nums.length) return '';
    for (var i = 1; i < nums.length; i++) if (nums[i] !== nums[0]) return '';
    return (about ? 'About ' : '') + nums[0] + ' servings per container';
  }

  function build() {
    var box = findDesc();
    if (!box || box.dataset.reTabs) return;
    box.dataset.reTabs = '1';
    var fullText = txt(box);
    var kids = [].slice.call(box.childNodes).filter(function (n) { return n.nodeType === 1 || txt(n); });
    var G = { o: { title: 'Overview', nodes: [] }, u: { title: 'How to use', nodes: [] }, i: { title: 'Ingredients', nodes: [] }, c: { title: 'Cautions', nodes: [] } };
    var fda = [], secs = [{ head: null, key: 'o', nodes: [] }];
    function keyFor(h) {
      if (/how to use|direction|recommended use|dosing|dosage|suggested use|instructions for use/i.test(h)) return 'u';
      if (/ingredient|supplement facts|nutrition facts|what.?s inside/i.test(h)) return 'i';
      if (/caution|warning|important|allergen|safety|storage|claims of use/i.test(h)) return 'c';
      return null;
    }
    kids.forEach(function (n) {
      if (n.nodeType === 3) { var p = el('p'); p.textContent = n.nodeValue.trim(); n = p; }
      if (isHead(n)) { secs.push({ head: n, key: keyFor(txt(n)), nodes: [] }); return; }
      var t = txt(n);
      if (/not been evaluated by the food and drug administration/i.test(t) && t.length < 400) { fda.push(n); return; }
      if (secs[secs.length - 1].key !== 'i' && (/^(allergens?|caution|warning|storage)\b/i.test(t) || /anaphylactic|allerg/i.test(t))) { G.c.nodes.push(n); return; }
      secs[secs.length - 1].nodes.push(n);
    });
    secs.forEach(function (sx) {
      var k = sx.key;
      if (!k) { var all = sx.nodes.map(txt).join(' '); k = /\b(scoops?|capsules?|pumps?)\b.*\bdaily\b|\b(children|adults)\b\s*[^:]{0,30}:/i.test(all) ? 'u' : 'o'; }
      if (sx.head && !(k === 'u' && /^how to use$/i.test(txt(sx.head))) && !(k === 'i' && /^ingredients$/i.test(txt(sx.head)))) {
        G[k].nodes.push(el('h3', 're-tabs__sub', txt(sx.head).replace(/:$/, '')));
      }
      sx.nodes.forEach(function (n) { G[k].nodes.push(n); });
    });
    var groups = ['o', 'u', 'i', 'c'].map(function (k) { return G[k]; }).filter(function (g) { return g.nodes.some(function (n) { return txt(n) || (n.querySelector && n.querySelector('img,table,iframe')); }); });
    if (groups.length < 2) {
      // No sections to split: keep the text in place, tidy it and set the FDA statement apart as fine print.
      if (fda.length) { fda.sort(function (a, b) { return txt(b).length - txt(a).length; }); fda.slice(1).forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); }); var f0 = el('div', 're-tabs__fda'); box.appendChild(f0); f0.appendChild(fda[0]); }
      tidy(box, false); box.classList.add('re-desc', 're-desc--plain');
      return;
    }

    var wrap = el('div', 're-tabs'), bar = el('div', 're-tabs__bar'), panels = el('div', 're-tabs__panels');
    bar.setAttribute('role', 'tablist'); bar.setAttribute('aria-label', 'Product details');
    var tabs = [], hasDose = false;
    groups.forEach(function (g, i) {
      var name = g.title.replace(/:$/, ''), id = 're-tab-' + slug(name);
      var b = el('button', 're-tabs__tab'); b.textContent = name;
      b.type = 'button'; b.id = id + '-tab'; b.setAttribute('role', 'tab'); b.setAttribute('aria-controls', id);
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false'); b.tabIndex = i === 0 ? 0 : -1; b.dataset.slug = slug(name);
      var p = el('div', 're-tabs__panel'); p.id = id; p.setAttribute('role', 'tabpanel'); p.setAttribute('aria-labelledby', b.id); p.tabIndex = 0; if (i) p.hidden = true;
      if (/how to use|directions/i.test(g.title)) {
        var d = dosingTable(g.nodes);
        if (d) { hasDose = true; p.appendChild(d.table); g.nodes.forEach(function (n) { if (d.used.indexOf(n) < 0) p.appendChild(n); }); }
        else g.nodes.forEach(function (n) { p.appendChild(n); });
      } else g.nodes.forEach(function (n) { p.appendChild(n); });
      tidy(p, /ingredient/i.test(g.title));
      if (/ingredient/i.test(g.title)) {
        [].forEach.call(p.querySelectorAll(':scope > ul'), function (ul) { var dl = factsList(ul); if (dl) ul.parentNode.replaceChild(dl, ul); });
      }
      bar.appendChild(b); panels.appendChild(p); tabs.push(b);
    });
    function select(b, focus) {
      tabs.forEach(function (x) {
        var on = x === b; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
        document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
      });
      if (focus) b.focus();
      try { b.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
    }
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () {
        select(b);
        if (history.replaceState) history.replaceState(null, '', '#' + b.dataset.slug);
      });
      b.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j !== null) { e.preventDefault(); select(tabs[j], true); }
      });
    });

    // At a glance: only facts found word for word in the label text.
    var facts = [];
    var sv = servings(fullText); if (sv) facts.push({ t: sv });
    if (hasDose) facts.push({ t: 'Dosing by age', go: 'how-to-use' });
    if (G.i.nodes.length) facts.push({ t: 'Full ingredient list', go: 'ingredients' });
    if (facts.length >= 2) {
      var gl = el('ul', 're-glance'); gl.setAttribute('role', 'list');
      facts.forEach(function (f) {
        var li = el('li', 're-glance__item');
        if (f.go) {
          var a = el('a', 're-glance__link'); a.href = '#' + f.go; a.textContent = f.t;
          a.addEventListener('click', function (e) {
            var tb = tabs.filter(function (x) { return x.dataset.slug === f.go; })[0];
            if (!tb) return; e.preventDefault(); select(tb); tb.scrollIntoView({ behavior: 'smooth', block: 'center' }); tb.focus({ preventScroll: true });
          });
          li.appendChild(a);
        } else li.textContent = f.t;
        gl.appendChild(li);
      });
      wrap.appendChild(gl);
    }
    wrap.appendChild(bar); wrap.appendChild(panels);
    if (fda.length) {
      // Keep one FDA statement: the longest one carries any extra caution sentence.
      fda.sort(function (a, b) { return txt(b).length - txt(a).length; });
      var f = el('div', 're-tabs__fda'); f.appendChild(fda[0]); wrap.appendChild(f);
    }
    box.innerHTML = ''; box.appendChild(wrap); box.classList.add('re-desc');

    var want = (location.hash || '').replace('#', '');
    var hit = tabs.filter(function (x) { return x.dataset.slug === want; })[0];
    if (hit) select(hit);
  }

  /* ---------- 4. Sticky add to cart (phones) ---------- */
  function sticky() {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;
    var head = document.querySelector('.re-pdp-head');
    var title = bar.querySelector('.sticky-add-to-cart__title');
    if (head && title && head.dataset.reName && title.textContent.trim() !== head.dataset.reName) title.textContent = head.dataset.reName;
    var picker = document.querySelector('.product-information variant-picker');
    if (!picker || bar.querySelector('.re-sticky-forms')) return;
    var sets = picker.querySelectorAll('fieldset.variant-option');
    if (sets.length !== 1) return;
    var inputs = [].slice.call(sets[0].querySelectorAll('input[type="radio"]'));
    if (inputs.length < 2 || inputs.length > 4) return;
    var row = el('div', 're-sticky-forms'); row.setAttribute('role', 'group'); row.setAttribute('aria-label', 'Form');
    inputs.forEach(function (inp) {
      var c = el('button', 're-sticky-forms__chip'); c.type = 'button'; c.textContent = inp.value; c.dataset.value = inp.value;
      c.addEventListener('click', function () {
        var live = [].filter.call(document.querySelectorAll('.product-information variant-picker fieldset input[type="radio"]'), function (x) { return x.value === c.dataset.value; })[0];
        if (live && !live.checked) live.click();
      });
      row.appendChild(c);
    });
    bar.insertBefore(row, bar.firstChild); bar.classList.add('has-re-forms');
    function sync() {
      var cur = document.querySelector('.product-information variant-picker fieldset input[type="radio"]:checked');
      [].forEach.call(row.children, function (c) {
        var live = [].filter.call(document.querySelectorAll('.product-information variant-picker fieldset input[type="radio"]'), function (x) { return x.value === c.dataset.value; })[0];
        c.setAttribute('aria-pressed', cur && cur.value === c.dataset.value ? 'true' : 'false');
        c.classList.toggle('is-out', !!live && live.dataset.optionAvailable === 'false');
      });
    }
    sync();
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(sync, 0); });
    new MutationObserver(function () { sync(); }).observe(picker, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] });
  }

  /* ---------- 5. Small polish ---------- */
  var PRICE = /\$(\d{1,3}(?:,\d{3})*)\.00(?!\d)/g;
  function tidyPrices() {
    [].forEach.call(document.querySelectorAll('.product-information product-price, .sticky-add-to-cart__price'), function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n;
      while ((n = w.nextNode())) { if (PRICE.test(n.nodeValue)) { PRICE.lastIndex = 0; n.nodeValue = n.nodeValue.replace(PRICE, '$$$1'); } PRICE.lastIndex = 0; }
    });
  }
  function thumbs() {
    [].slice.call(document.querySelectorAll('.product-information .slideshow-controls__thumbnail img[loading="lazy"], .product-information .slideshow-controls__thumbnails img[loading="lazy"]'), 0)
      .slice(0, 6).forEach(function (img) { img.loading = 'eager'; });
  }

  var queued = false;
  function run() {
    queued = false;
    try { build(); } catch (e) { if (window.console) console.warn('[re-product] tabs', e); }
    try { sticky(); } catch (e) {}
    try { tidyPrices(); } catch (e) {}
    try { thumbs(); } catch (e) {}
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(run); } }
  function init() {
    run();
    // Variant changes morph parts of the page; re-apply the polish (tabs rebuild only if the description was replaced).
    var root = document.querySelector('.product-information');
    if (root) new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) if (!list[i].target.closest || !list[i].target.closest('.re-tabs,.re-sticky-forms')) { queue(); return; }
    }).observe(root, { subtree: true, childList: true, characterData: true });
    var sb = document.querySelector('sticky-add-to-cart');
    if (sb) new MutationObserver(queue).observe(sb, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
